export const allCountries = [
    {
        "name": "United States",
        "code": "US",
        "region": "NA",
        "zipPattern" : /^\d{5}(-\d{4})?$/,
    },
    {
        "name": "Canada",
        "code": "CA",
        "region": "NA",
        "zipPattern" : /^[ABCEGHJKLMNPRSTVXY]\d[A-Z][ ]{0,1}?\d[A-Z]\d$/i,
    },
    {
        "name": "Mexico",
        "code": "MX",
        "region": "NA",
        "zipPattern" : /^\d{5}(-\d{4})?$/,
    },
    {
        "name": "Northern Mariana Islands",
        "code": "MP",
        "region": "NA",
        "zipPattern" : /^\d{5}(-\d{4})?$/,
    },
    {
        "name": "Guam",
        "code": "GU",
        "region": "NA",
        "zipPattern" : /^\d{5}(-\d{4})?$/,
    },
    {
        "name": "American Samoa",
        "code": "AS",
        "region": "NA",
        "zipPattern" : /^\d{5}(-\d{4})?$/,
    },
    {
        "name": "Bermuda",
        "code": "BM",
        "region": "NA",
        "zipPattern" : /^[A-Z0-9]{2} [A-Z0-9]{2}$/,
    },
    {
        "name": "United Kingdom",
        "code": "GB",
        "region": "EU",
        "zipPattern" : /^[A-Z0-9]{2,4}\s[A-Z0-9]{3}$/,
    },
    {
        "name": "France",
        "code": "FR",
        "region": "EU",
        "zipPattern" : /^\d{5}$/,
    },
    {
        "name": "Netherlands",
        "code": "NL",
        "region": "EU",
        "zipPattern" : /^\d{4}(\s[A-Z0-9]{2})?$/,
    },
    {
        "name": "Germany",
        "code": "DE",
        "region": "EU",
        "zipPattern" : /^\d{5}$/,
    },
    {
        "name": "Italy",
        "code": "IT",
        "region": "EU",
        "zipPattern" : /^\d{5}$/,
    },
    {
        "name": "Spain",
        "code": "ES",
        "region": "EU",
        "zipPattern" : /^\d{5}$/,
    },
    {
        "name": "Denmark",
        "code": "DK",
        "region": "EU",
        "zipPattern" : /^\d{4}$/,
    },
    {
        "name": "Belgium",
        "code": "BE",
        "region": "EU",
        "zipPattern" : /^\d{4}$/,
    },
    {
        "name": "Austria",
        "code": "AT",
        "region": "EU",
        "zipPattern" : /^\d{4}$/,
    },
    {
        "name": "Switzerland",
        "code": "CH",
        "region": "EU",
        "zipPattern" : /^\d{4}$/,
    },
    {
        "name": "Luxembourg",
        "code": "LU",
        "region": "EU",
        "zipPattern" : /^\d{4}$/,
    },
    {
        "name": "Norway",
        "code": "NO",
        "region": "EU",
        "zipPattern" : /^\d{4}$/,
    },
    {
        "name": "Sweden",
        "code": "SE",
        "region": "EU",
        "zipPattern" : /^\d{3}\s\d{2}$/,
    },
    {
        "name": "Ireland",
        "code": "IE",
        "region": "EU",
        "zipPattern" : /^[A-Z0-9]{3}\s[A-Z0-9]{4}$/,
    },
    {
        "name": "Portugal",
        "code": "PT",
        "region": "EU",
        "zipPattern" :/^\d{4}-\d{3}$/,
    },
    {
        "name": "Australia",
        "code": "AU",
        "region": "EU",
        "zipPattern" :/^\d{4}$/,
    },    
    {
        "name": "New Zealand",
        "code": "NZ",
        "region": "EU",
        "zipPattern" :/^\d{4}$/,
    },
    {
        'name': 'Greece',
        'code': 'GR',
        'region': 'EU',
        'zipPattern': /^\d{3} \d{2}$/
    },
    {
        'name' : 'Romania',
        'code' : 'RO',
        'region': 'EU',
        'zipPattern': /^\d{6}$/
    },
    {
        'name' : 'Poland',
        'code' : 'PL',
        'region': 'EU',
        'zipPattern': /^\d{2}-\d{3}$/
    },
    {
        'name' : 'Slovenia',
        'code' : 'SI',
        'region': 'EU',
        'zipPattern' : /^\d{4}$/,
    },
    {
        'name' : 'Croatia',
        'code' : 'HR',
        'region': 'EU',
        'zipPattern' : /^\d{5}$/,
    },
    {
        "name" : "Andorra",
        "code" : "AD",
        "region": "EU",
        "zipPattern" : /^AD\d{3}$/,
    },

    {
        'name' : 'Liechtenstein',
        'code' : 'LI',
        'region': 'EU',
        'zipPattern' : /^\d{4}$/,
    },
    {
        'name' : 'Monaco',
        'code' : 'MC',
        'region': 'EU',
        'zipPattern' : /^980\d{2}$/,
    },
    {
        'name' : 'San Marino',
        'code' : 'SM',
        'region': 'EU',
        'zipPattern' : /^4789\d{1}$/,
        
    },
    {
        'name' : 'Vatican City',
        'code' : 'VA',
        'region': 'EU',
        'zipPattern' : /^00120$/,
    },
    {
        'name' : 'Isle of Man',
        'code' : 'IM',
        'region': 'EU',
        'zipPattern' : /^IMN [A-Za-z0-9]{4}$/,
    },
    {
        'name' : 'Gibraltar',
        'code' : 'GI',
        'region': 'EU',
        'zipPattern' : /^GX11 1AA$/,
    },
    {
        'name' : 'Bulgaria',
        'code' : 'BG',
        'region': 'EU',
        'zipPattern' : /^\d{4}$/,
    },
    {
        'name' : 'Cyprus',
        'code' : 'CY',
        'region': 'EU',
        'zipPattern' : /^\d{4}$/,
    },
    {
        "name" : "Czechia",
        "code" : "CZ",
        "region": "EU",
        "zipPattern" : /^\d{3} \d{2}$/,
    },
    {
        'name' : 'Estonia',
        'code' : 'EE',
        'region': 'EU',
        'zipPattern' : /^\d{5}$/,
    },
    {
        'name' : 'Finland',
        'code' : 'FI',
        'region': 'EU',
        'zipPattern' : /^\d{5}$/,
    },
    {
        'name' : 'Hungary',
        'code' : 'HU',
        'region': 'EU',
        'zipPattern' : /^\d{4}$/,
    },
    {
        'name' : 'Latvia',
        'code' : 'LV',
        'region': 'EU',
        'zipPattern' : /^LV-\d{4}$/,
    },
    {
        'name' : 'Lithuania',
        'code' : 'LT',
        'region': 'EU',
        'zipPattern' : /^LT-\d{5}$/,
    },
    {
        'name' : 'Malta',
        'code' : 'MT',
        'region': 'EU',
        'zipPattern' : /^[A-Za-z]{3} \d{4}$/,
    },
    {
        'name' : 'Slovakia',
        'code' : 'SK',
        'region': 'EU',
        'zipPattern' : /^\d{3} \d{2}$/,
    },
    {
        'name' : 'Åland Islands',
        'code' : 'AX',
        'region': 'EU',
        'zipPattern' : /^[A-Za-z]{2}-\d{5}$/,
    },
    {
        'name' : 'Brazil',
        'code' : 'BR',
        'region': 'EU',
        'zipPattern' : /^\d{5}-\d{3}$/,
    },
];

let naCountries = [...allCountries.filter(country => country.region === "NA")];
let euCountries = [...allCountries.filter(country => country.region === "EU")];

export function getCountriesList(flagCheck) {
    return flagCheck ? allCountries : naCountries
}

export function countryCodeExists(countryCode) {
    return euCountries.some(country => country.code === countryCode);
}